import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { baseCompList,RsNgBaseModule } from 'rs-ng-base';
import { RsNgStepsComponent } from './rs-ng-steps.component';
import { NzStepsModule } from 'ng-zorro-antd/steps';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { RsNgCommonModule } from 'rs-ng-common';
@NgModule({
  declarations: [RsNgStepsComponent],
  imports: [
    CommonModule,
    NzStepsModule,
    RsNgCommonModule,
    NzButtonModule,
    RsNgBaseModule
    
  ],
  exports: [
    RsNgStepsComponent
  ],
  entryComponents: [
    ...baseCompList
  ]
})
export class RsNgStepsModule { }
